module.exports = __webpack_public_path__ + "img/gift3-01-c01.dc608599.png";